import { useEffect, useState } from "react";
import FormStepper from "../components/stepper";
import { Container, Typography, Grid } from "@mui/material";
import { getPrice } from "../service/api";

const BookScreen = () => {
  const [mainHeading, setMainHeading] = useState(
    `Get Instant Quote <br /> & Book A Removal Job`
  );
  const [scripts, setScripts] = useState();

  const getScripts = async () => {
    try {
      const {
        bookingFormStep1,
        bookingFormStep2,
        bookingFormStep3,
        bookingFormStep4,
      } = await getPrice();
      setScripts({
        bookingFormStep1,
        bookingFormStep2,
        bookingFormStep3,
        bookingFormStep4,
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getScripts();
  }, []);
  return (
    <Container>
      <Typography variant="h5" color={"primary"} align="center" mb={2}>
        <p dangerouslySetInnerHTML={{ __html: mainHeading }} />
      </Typography>

      <FormStepper setMainHeading={setMainHeading} scripts={scripts} />
    </Container>
  );
};

export default BookScreen;
